import { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  Button,
  FlexRow,
  HeaderText,
  PageTile,
  TableRow,
  TableRowType
} from '@make-software/cspr-design';
import Table from 'app/components/common/table/table';
import BaseTableHeader from 'app/components/common/base-table/base-table-header';
import { ErrorResult, Pagination } from 'app/organizations-api/types';
import { InviteUserResponseType } from 'app/organizations-api';
import { UserListItem } from './user-list-item';
import { TablePageContainer } from 'app/components/common/common-styles';

interface UserListProps {
  loading: boolean;
  pageCount: number;
  error?: ErrorResult | null;
  users: InviteUserResponseType[] | null;
  refetch?: (page: number, limit: number) => void;
  onOpenEditUserWindow: (user: InviteUserResponseType) => void;
}

export const UserList = ({
  users,
  loading,
  error,
  refetch,
  onOpenEditUserWindow,
  pageCount
}: UserListProps) => {
  const [pagination, setPagination] = useState<Pagination>({ currentPage: 1, pageSize: 5 });
  const [userData, setUserData] = useState<InviteUserResponseType[] | null>(null);

  useEffect(() => {
    users && setUserData([...users]);
  }, [users]);

  const handleOpenEditUserWindow = (user: InviteUserResponseType) => {
    onOpenEditUserWindow(user);
  };

  const handlePageActions = (page: number, limit: number) => {
    if (pagination.pageSize != limit) {
      page = 1;
    }
    setPagination((prev) => ({
      ...prev,
      currentPage: page,
      pageSize: limit
    }));
    refetch && refetch(page, limit);
  };

  return (
    <TablePageContainer>
      <Table
        loading={loading}
        data={userData}
        pageCount={pageCount}
        error={error}
        pageSize={pagination.pageSize}
        currentPage={pagination.currentPage}
        handlePageActions={handlePageActions}
        tableRowType={TableRowType.TextSingleLine}
        renderDataHeader={() => (
          <TableRow>
            <BaseTableHeader fixedWidthRem={30}>User Name</BaseTableHeader>
            <BaseTableHeader fixedWidthRem={40}>User Email</BaseTableHeader>
            <BaseTableHeader fixedWidthRem={5}>Status</BaseTableHeader>
            <BaseTableHeader align="right">Action</BaseTableHeader>
          </TableRow>
        )}
        renderPaginatedData={(invitedUser) => {
          return invitedUser.map((user) => (
            <UserListItem key={user.id} user={user} onOpenEditWindow={handleOpenEditUserWindow} />
          ));
        }}
      />
    </TablePageContainer>
  );
};
